import React, { useMemo } from 'react';
import type Trip from '@this/domain/trip/trip2';
import type { ForbiddenRepositoryArgs } from '@this/domain/organization/organization3';

interface Props {
  trip: Trip;
}

export const SmasInfo: React.FC<Props> = ({ trip }) => {
  const smasForbidden = useMemo((): boolean | null => {
    const repos: ForbiddenRepositoryArgs[] | undefined = trip?.forbiddenRepositories;
    if (!repos) return null;
    return repos.some(r => r.category === 'rentalcar' && r.repository === 'smas');
  }, [trip]);

  let smasLabel = '';
  if (smasForbidden !== null && smasForbidden !== undefined) {
    smasLabel = smasForbidden ? '利用しない' : '利用する';
  }

  if (!smasLabel) {
    return null;
  }

  return <p>SMAS：{smasLabel}</p>;
};
